import { NgModule } from '@angular/core';

import { MatDividerModule } from '@angular/material/divider';

import { SharedModule } from 'shared/shared.module';
import { FcpButtonModule, FcpIconModule } from 'fc-ui-components';
import { ComponentsModule } from 'components/components.module';
import { DownloadSelectionModalModule } from 'app/content/components/download-selection-modal/download-selection-modal.module';

import { DownloadCartComponent } from './download-cart.component';

@NgModule({
    imports: [
        SharedModule,
        ComponentsModule,
        MatDividerModule,
        FcpButtonModule,
        FcpIconModule,
        DownloadSelectionModalModule
    ],
    declarations: [DownloadCartComponent],
    exports: [DownloadCartComponent]
})
export class DownloadCartModule {}
